module.exports = __webpack_public_path__ + "static/assets/dcf48229839085891015a1385d73323d.svg";